// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Patient List — Actions dropdown polish (v2: align="end" handles position) */
.dropdown-menu.leadActionsMenu,
#dropdown-basic-button ~ .dropdown-menu {
  background-color: #C7C7C7 !important;
  min-width: 12rem !important;
}
.dropdown-menu.leadActionsMenu .dropdown-item:hover,
.dropdown-menu.leadActionsMenu .dropdown-item:focus,
#dropdown-basic-button ~ .dropdown-menu .dropdown-item:hover,
#dropdown-basic-button ~ .dropdown-menu .dropdown-item:focus {
  background-color: #FFD400 !important;
  color: #000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Screens/HR/leadActionsMenu.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;;;;EAIE,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":["/* Patient List — Actions dropdown polish (v2: align=\"end\" handles position) */\n.dropdown-menu.leadActionsMenu,\n#dropdown-basic-button ~ .dropdown-menu {\n  background-color: #C7C7C7 !important;\n  min-width: 12rem !important;\n}\n.dropdown-menu.leadActionsMenu .dropdown-item:hover,\n.dropdown-menu.leadActionsMenu .dropdown-item:focus,\n#dropdown-basic-button ~ .dropdown-menu .dropdown-item:hover,\n#dropdown-basic-button ~ .dropdown-menu .dropdown-item:focus {\n  background-color: #FFD400 !important;\n  color: #000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
